export default __webpack_public_path__ + "static/media/werkschau_nicolajaeger.49606700.png";